module.exports = __webpack_public_path__ + "static/media/badge.abebde7b.png";